import { Box, CardMedia, Container, Typography } from '@mui/material'
import React from 'react'
import vid from "../../assets/anpout-prof-s.mp4"

function LeaderMessage({ desc, img }) {
    return (
        <Container>
            <Box sx={{ display: { md: "flex", xs: "flex" }, flexDirection: { md: 'row', xs: 'column' } }} alignItems={"center"} gap={2} justifyContent={"space-between"} >
                <Typography
                    variant="subtitle1"
                    color={"GrayText"}
                    sx={{
                        maxWidth: { md: "50%", xs: "100%" },
                        fontSize: 16,
                        lineHeight: 1.2,
                        padding: 4
                    }}
                    className="cardTestim"
                >{desc}
                </Typography>
                {/* <CardMedia
                    component="img"
                    sx={{ width: { md: '45%', xs: '100%' }, height: '300px', borderRadius: '30px' }}
                    image={img}
                /> */}
                <Box className="" sx={{
                    mt: { md: 0, xs: 0 },

                }}>
                    <Box className='' sx={{ display: 'flex', mt: { md: '15px', xs: 0 }, justifyContent: 'center' }} >
                        <video autoPlay={true} muted src={vid} loop width={'90%'} height={'100%'} style={{ borderBottomLeftRadius: '80px', borderBottomRightRadius: '80px' }} >
                            Your browser does not support the video tag.
                        </video>
                    </Box>
                </Box>
            </Box>
        </Container>
    )
}

export default LeaderMessage